const customBedwarsProject = {
  id: "customBedwars",
  title: "Custom Bedwars Events",
  titleIntro: "What are Custom Bedwars Events?",
  role: "Owner, Plugin Developer",
  startDate: "August 2021",
  endDate: "September 2022",
  banner: "/bedwars/bedwarsheader.png",
  detailBanner: "/bedwars/bwbanner.png",
  overview: [
    "Custom Bedwars Events were an attempt by me to create 'Minecraft, but' style content in a more unique format.",
    "This project is where I learned to develop Minecraft plugins. I took an open source Bedwars plugin and created an addon implementing hundreds of features.",
    "Features include:",
    "- 50+ gameplay scenarios",
    "- 22 unique maps built by myself",
    "- 20+ special items impacting gameplay",
    "- 64+ original unlockable cosmetics",
    "- Unlockable cosmetic systems via coin shops and progression based unlocks",
    "- A queue system, randomizing the next available map and allowing players to skip maps they dislike",
    "- Party system support allowing players to easily play with friends",
    "- A bedfight gamemode allowing players to play short 1v1 matches on smaller maps",
    "- A system to switch PVP versions between classic 1.8 and modern 1.9 styles with a click of a button.",
    "The server for this project is open to anyone. The server is setup with the intention of allowing small groups to play private matches together. Occasionally, I whitelist the server to run private events for content creators & friends.",
    "Feel free to checkout the project ingame by connecting to bedwars.invic.cc on Minecraft 1.21.1."
  ],
  nextPreview: "Here are some of my favorite features of this project:",
  features: [
    {
      id: "bedwarsMaps",
      title: "Bedwars Maps",
      pretext: "I created 22 unique maps for this project. Here's some info about my favorites maps.",
      description: [
        "Most maps were built be myself from the ground up. Some have layouts influenced by popular Hypixel Bedwars maps and some are rearranged versions of maps I was given to use.",
        "Most maps were built in the traditional bedwars style while some were fine tuned for specific scenarios or events.",
        "Creating these maps allowed me to learn how to balance good level design elements with visuals that were not overally detailed. I also got to get creative with some of the more unique maps:",
        " - The map in the last image, called Multiverse, was a mashup map of many others created for a special 4v100 event. It's massive size and advantage scewed towards the smaller team made the game playout very well despite the odds."
        ," - The map in the second to last image, called Atlantis, was a mostly underwater map. A special underwater shop was introduced selling dolphin spawn eggs, riptide tridents, and other underwater items. Conduits were placed at islands around the map so players were incentivized to stay near optimal paths.",
        "- The map in the third to last image, called Skylantis, was a much more spaced out version of Atlantis in the sky.",
        " This map was created for a content creator event in which one round gave both players elytras if they were close to each other. This forced players to make good use of teamwork in order to traverse the map as it was too large to bridge between islands and the elytras required good coordination to use properly.",
      "- The map in the fifth to last image, called Sculk, was a map that featured naturally spawning wardens. Players could intentionally trigger sculk catalysts to harm other players. Because of the prevalence of wool in Bedwars, Wardens were fairly reasonable to avoid.",
      ],
      images: [
        "/bedwars/map1.png",
        "/bedwars/map2.png",
        "/bedwars/map3.png",
        "/bedwars/map4.png",
        "/bedwars/map5.png",
        "/bedwars/map6.png",
        "/bedwars/map7.png",
        "/bedwars/map15.png",
        "/bedwars/map8.png",
        "/bedwars/map9.png",
        "/bedwars/map14.png",
        "/bedwars/map10.png",
        "/bedwars/map11.png",
      ],
      featuredImage: "/bedwars/map12.png",
    },
    {
      id: "cosmetics",
      title: "Cosmetics",
      pretext: "I created over 64 unique cosmetics that could be unlocked by players. Here are some of my favorites.",
      video: "https://www.youtube.com/embed/sxp9N35-1_w",
      description: [
        "I spent hundreds of hours working on the visuals and sound designs of various cosmetics. This became invaluable experience that I would later use in other projects due to my familiarity with creating visual effects through plugins.",
        "Some cosmetics were high enough quality to be implemented on Hoplite either as cosmetics or as visual effects for Legendary Weapons.",
      ],
    },
    {
      id: "bedfightGamemode",
      title: "Bedfight Gamemode",
      video: "/bedwars/bedfightshowcase.mp4",
      pretext: "I created a second bedwars gamemode that allowed players to play 1v1 matches on smaller maps.",
      description: [
        "I included some design elements that I believe improve on other servers' implementations of the Bedfight gamemode:",
        "- Instead of preventing players from building close to spawnpoints, blocks instead rapidly decay.",
        "- Instead of blocks not placing when players get too high, blocks rapdily decay with the decay speed increasing for each y level.",
        "This creates a dynamic where players constantly have to outwit each other with their block placements instead of the match being determined by flatground fights.",
        "- I created an algorithm that spawns configurable bed defences when the game starts. This creates an aesthetically pleasing visual and sound as the game begins.",
        "- I added cage cosmetics that players spawn in at the start of the game. Players can begin the match early if every player sneaks during the countdown, removing the annoying waiting period if every player chooses to do so.",
        "I found this game to be extremely replayable even with small groups of players. Combined with the scenario options, this gamemode has more longevity than one would expect from such a gamemode."
      ],
    },
  ],
};

export default customBedwarsProject; 